import Home from '../pages/frontend/Home';
import Education from '../pages/frontend/education/Educations';
import EducationDetails from '@/pages/frontend/education/EducationDetails';
import DesignDetails from '@/pages/frontend/design/DesignDetails';
import Designs from '@/pages/frontend/design/Designs';
import Team from '@/pages/frontend/team/Team';
import TeamDetails from '@/pages/frontend/team/TeamDetails';
import News from '@/pages/frontend/news/News';
import Partners from '@/pages/frontend/partner/Partners';
import NewsDetails from '@/pages/frontend/news/NewsDetails';
import EducationsRouter from '@/pages/frontend/education/EducationsRouter';
import Search from '@/pages/frontend/search/Search';
import NotFound from '@/pages/frontend/404';
import Archive from '@/pages/frontend/education/Archive';
import Resources from '@/pages/frontend/resource/Resources';
import Merch from '@/pages/frontend/merch/Merch';

export default [
  {
    path: '/',
    component: Home,
    name: 'home',
    meta: { transitionName: 'slide', index: 0 },
  },
  {
    path: '/search',
    component: Search,
    name: 'search',
    meta: { transitionName: 'slide', index: 1 },
  },
  {
    path: '/archive',
    component: Archive,
    name: 'archive',
  },
  {
    path: '/education',
    component: Education,
    name: 'education',
    meta: { transitionName: 'slide', index: 2 },
  },
  {
    path: '/education/:slug',
    component: EducationsRouter,
    name: 'education-detail',
  },
  {
    path: 'education/:slug',
    component: EducationsRouter,
    name: 'education-degree-detail',
  },
  {
    path: '/education/:slug',
    component: EducationsRouter,
    name: 'education-degree-masters-detail',
  },
  {
    path: '/education/:slug',
    component: EducationsRouter,
    name: 'education-degree-phd-detail',
  },
  {
    path: '/masters/:slug',
    component: EducationsRouter,
    name: 'education-masters-detail-old', // Fallback, this is now the 'degree/slug' route
  },
  {
    path: '/degree/:slug',
    component: EducationsRouter,
    name: 'education-masters-detail',
  },
  {
    path: '/design',
    component: Designs,
    name: 'design',
    meta: { transitionName: 'slide', index: 3 },
  },
  { path: '/design/:slug', component: DesignDetails, name: 'design-detail' },
  {
    path: '/merch',
    component: Merch,
    name: 'merch',
    meta: { transitionName: 'slide', index: 4 },
  },
  {
    path: '/team',
    component: Team,
    name: 'team',
    meta: { transitionName: 'slide', index: 5 },
  },
  {
    path: '/team/:slug',
    component: TeamDetails,
    name: 'team-detail',
  },
  {
    path: '/partners',
    component: Partners,
    name: 'partners',
    meta: { transitionName: 'slide', index: 6 },
  },
  {
    path: '/news',
    component: News,
    name: 'news',
    meta: { transitionName: 'slide', index: 7 },
  },
  {
    path: '/news/:slug',
    component: NewsDetails,
    name: 'news-detail',
  },
  {
    path: '/resources',
    component: Resources,
    name: 'resources',
    meta: { transitionName: 'slide', index: 8 },
  },
  {
    path: '*',
    component: NotFound,
    name: '404',
    meta: { transitionName: 'slide', index: 7 },
  },
];
